'use strict';

(() => {
  const separarMiles = (numero, separador) => numero.replace(/\B(?=(\d{3})+(?!\d))/g, separador);

  function formatearDinero(centavos, formato) {
    const valor = Number(centavos) / 100;
    const conDecimales = (miles, decimal) => {
      const [entero, dec] = valor.toFixed(2).split('.');
      return separarMiles(entero, miles) + decimal + dec;
    };
    const sinDecimales = (miles) => separarMiles(Math.round(valor).toString(), miles);
    const reemplazos = {
      amount: () => conDecimales(',', '.'),
      amount_no_decimals: () => sinDecimales(','),
      amount_with_comma_separator: () => conDecimales('.', ','),
      amount_no_decimals_with_comma_separator: () => sinDecimales('.'),
      amount_with_apostrophe_separator: () => conDecimales("'", '.'),
      amount_no_decimals_with_space_separator: () => sinDecimales(' '),
      amount_with_space_separator: () => conDecimales(' ', ','),
      amount_with_period_and_space_separator: () => conDecimales(' ', '.'),
    };
    return (formato || '${{amount_no_decimals_with_comma_separator}}').replace(/{{\s*(\w+)\s*}}/, (_, clave) =>
      (reemplazos[clave] || reemplazos.amount_no_decimals_with_comma_separator)(),
    );
  }

  const interpolar = (texto, valores) => texto.replace(/__(\w+)__/g, (_, clave) => valores[clave] ?? '');

  function iniciarProducto(raiz) {
    const datos = JSON.parse(raiz.parentElement.querySelector('[data-producto-datos]').textContent);
    const dinero = (centavos) => formatearDinero(centavos, datos.formato);
    const form = document.getElementById(raiz.dataset.form);
    const entradaVariante = form.querySelector('[data-input-variante]');
    const entradaCantidad = form.querySelector('[data-input-cantidad]');
    const contenedorPaquetes = raiz.querySelector('[data-paquetes]');
    const modo = contenedorPaquetes ? contenedorPaquetes.dataset.modo : 'ninguno';
    const tarjetas = contenedorPaquetes ? [...contenedorPaquetes.querySelectorAll('[data-paquete]')] : [];
    const total = raiz.querySelector('[data-total]');
    let variante = datos.variantes.find((v) => String(v.id) === entradaVariante.value) || datos.variantes[0];
    let paqueteActivo = modo === 'informativo' ? null : tarjetas.find((t) => t.getAttribute('aria-pressed') === 'true') || null;

    function estado() {
      if (modo === 'informativo') {
        const minimo = Math.min(...tarjetas.map((t) => Number(t.dataset.precio)));
        const texto = dinero(minimo);
        return { precio: minimo, texto, etiqueta: interpolar(datos.textos.desde, { precio: texto }), paquete: '' };
      }
      if (paqueteActivo) {
        const precio = Number(paqueteActivo.dataset.precio);
        const texto = dinero(precio);
        return { precio, texto, etiqueta: texto, paquete: paqueteActivo.dataset.nombre };
      }
      const precio = variante.precio * Number(entradaCantidad.value || 1);
      const texto = dinero(precio);
      return { precio, texto, etiqueta: texto, paquete: variante.titulo };
    }

    function publicar() {
      const e = estado();
      window.zoremina = { ...e, modo };
      if (total && modo !== 'informativo') {
        total.innerHTML = '';
        total.append(`${datos.textos.paqueteElegido}: `);
        const fuerte = document.createElement('strong');
        fuerte.textContent = e.texto;
        total.append(fuerte);
      }
      const precioCarrito = dinero(variante.precio * Number(entradaCantidad.value || 1));
      raiz.querySelectorAll('[data-precio-boton]').forEach((el) => {
        el.textContent = precioCarrito;
      });
      raiz.querySelectorAll('[data-whatsapp]').forEach((el) => {
        const mensaje = interpolar(datos.textos.whatsapp, { paquete: e.paquete || variante.titulo, precio: e.texto });
        el.href = `https://wa.me/${el.dataset.whatsapp}?text=${encodeURIComponent(mensaje)}`;
      });
      document.dispatchEvent(new CustomEvent('zoremina:precio', { detail: window.zoremina }));
    }

    function pintarPrecio() {
      const bloque = raiz.querySelector('[data-bloque="precio"]');
      if (!bloque) return;
      const hayDescuento = variante.antes > variante.precio;
      bloque.querySelector('[data-precio-actual]').textContent = dinero(variante.precio);
      bloque.querySelector('[data-precio-antes]').hidden = !hayDescuento;
      bloque.querySelector('[data-descuento]').hidden = !hayDescuento;
      bloque.querySelector('[data-ahorro]').hidden = !hayDescuento;
      if (hayDescuento) {
        const ahorro = variante.antes - variante.precio;
        bloque.querySelector('[data-precio-antes-valor]').textContent = dinero(variante.antes);
        bloque.querySelector('[data-descuento]').textContent = interpolar(datos.textos.descuento, {
          porcentaje: Math.floor((ahorro * 100) / variante.antes),
        });
        bloque.querySelector('[data-ahorro]').textContent = interpolar(datos.textos.ahorras, { amount: dinero(ahorro) });
      }
    }

    function pintarStock() {
      const stock = raiz.querySelector('[data-stock]');
      if (!stock) return;
      const umbral = Number(stock.dataset.umbral);
      const visible = variante.inventario !== null && variante.inventario > 0 && variante.inventario <= umbral;
      stock.hidden = !visible;
      if (visible) stock.querySelector('[data-stock-texto]').textContent = interpolar(datos.textos.stock, { count: variante.inventario });
    }

    function usarVariante(nueva) {
      if (!nueva) return;
      variante = nueva;
      entradaVariante.value = nueva.id;
      pintarPrecio();
      pintarStock();
    }

    function activarPaquete(tarjeta) {
      paqueteActivo = tarjeta;
      tarjetas.forEach((t) => {
        const activa = t === tarjeta;
        t.classList.toggle('es-activo', activa);
        t.setAttribute('aria-pressed', String(activa));
      });
      entradaCantidad.value = tarjeta.dataset.cantidad;
      if (modo === 'variante') {
        usarVariante(datos.variantes.find((v) => String(v.id) === tarjeta.dataset.variante));
      }
      publicar();
    }

    function abrirFormulario() {
      const app = raiz.querySelector('[data-app]');
      if (app && app.querySelector('input, select, textarea')) {
        app.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
        return;
      }
      const boton = app && app.querySelector('button, [role="button"], a[href]');
      if (boton) {
        boton.click();
        return;
      }
      location.hash = 'comprar';
    }

    tarjetas.forEach((tarjeta) => {
      tarjeta.addEventListener('click', () => {
        if (modo === 'informativo') abrirFormulario();
        else activarPaquete(tarjeta);
      });
    });

    const selectores = [...raiz.querySelectorAll('[data-bloque="variantes"] select')];
    selectores.forEach((select) => {
      select.addEventListener('change', () => {
        const elegidas = selectores.map((s) => s.value);
        usarVariante(datos.variantes.find((v) => elegidas.every((valor, i) => v.opciones[i] === valor)));
        publicar();
      });
    });

    if (paqueteActivo) activarPaquete(paqueteActivo);
    else publicar();
  }

  function iniciarContador(contador) {
    const fin = Number(contador.dataset.fin) * 1000;
    const campos = ['dias', 'horas', 'minutos', 'segundos'].map((c) => contador.querySelector(`[data-${c}]`));
    const dosCifras = (n) => String(n).padStart(2, '0');
    const pintar = () => {
      const resto = Math.floor((fin - Date.now()) / 1000);
      if (resto <= 0) {
        contador.remove();
        clearInterval(intervalo);
        return;
      }
      const valores = [Math.floor(resto / 86400), Math.floor((resto % 86400) / 3600), Math.floor((resto % 3600) / 60), resto % 60];
      campos.forEach((campo, i) => {
        if (campo) campo.textContent = dosCifras(valores[i]);
      });
    };
    const intervalo = setInterval(pintar, 1000);
    pintar();
  }

  function iniciarGaleria(galeria) {
    const pista = galeria.querySelector('[data-galeria-pista]');
    const slides = [...galeria.querySelectorAll('[data-galeria-slide]')];
    const minis = [...galeria.querySelectorAll('[data-galeria-mini]')];
    const puntos = [...galeria.querySelectorAll('[data-galeria-punto]')];
    if (slides.length < 2) return;
    let actual = 0;
    const ir = (indice) => {
      const destino = (indice + slides.length) % slides.length;
      pista.scrollTo({ left: slides[destino].offsetLeft - pista.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };
    const marcar = (indice) => {
      actual = indice;
      minis.forEach((m, i) => {
        m.classList.toggle('es-activo', i === indice);
        if (i === indice) m.setAttribute('aria-current', 'true');
        else m.removeAttribute('aria-current');
      });
      puntos.forEach((p, i) => p.classList.toggle('es-activo', i === indice));
    };
    const observador = new IntersectionObserver(
      (entradas) => {
        entradas.forEach((e) => {
          if (e.isIntersecting) marcar(slides.indexOf(e.target));
        });
      },
      { root: pista, threshold: 0.6 },
    );
    slides.forEach((s) => observador.observe(s));
    minis.forEach((m) => m.addEventListener('click', () => ir(Number(m.dataset.galeriaMini))));
    galeria.querySelector('[data-galeria-ant]')?.addEventListener('click', () => ir(actual - 1));
    galeria.querySelector('[data-galeria-sig]')?.addEventListener('click', () => ir(actual + 1));
    pista.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') ir(actual + 1);
      if (e.key === 'ArrowLeft') ir(actual - 1);
    });
  }

  document.querySelectorAll('[data-galeria]').forEach(iniciarGaleria);
  document.querySelectorAll('[data-contador]').forEach(iniciarContador);
  document.querySelectorAll('[data-producto]').forEach(iniciarProducto);
})();
